/**
 * Spanish translations
 *
 * Machine-translated - requires professional review
 */
import type { TranslationStructure } from '../types';

export const es: TranslationStructure = {
  common: {
    appName: 'Dashboard',
    loading: 'Cargando...',
    loadingDashboard: 'Cargando Panel...',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    adding: 'Agregando...',
    create: 'Crear',
    update: 'Actualizar',
    submit: 'Enviar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    ok: 'OK',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    all: 'Todos',
    none: 'Ninguno',
    search: 'Buscar',
    filter: 'Filtrar',
    filters: 'Filtros',
    reset: 'Restablecer',
    refresh: 'Actualizar',
    download: 'Descargar',
    upload: 'Subir',
    view: 'Ver',
    details: 'Detalles',
    actions: 'Acciones',
    status: 'Estado',
    date: 'Fecha',
    time: 'Hora',
    name: 'Nombre',
    email: 'Correo electrónico',
    description: 'Descripción',
    notes: 'Notas',
    type: 'Tipo',
    user: 'Usuario',
    role: 'Rol',
    organization: 'Organización',
    required: 'Requerido',
    optional: 'Opcional',
    notAvailable: 'N/D',
    other: 'Otro',
    goBack: 'Volver',
  },

  roles: {
    admin: 'Administrador',
    pilot: 'Piloto',
    maintenance: 'Mantenimiento',
    airspace_observer: 'Observador de Espacio Aéreo',
  },

  profile: {
    myProfile: 'Mi Perfil',
    userProfile: 'Perfil de Usuario',
    loadError: 'Error al cargar el perfil',
    notFound: 'Perfil no encontrado',
    bio: 'Biografía',
    bioPlaceholder: 'Cuéntanos sobre ti...',
    noBio: 'Aún no se ha añadido biografía.',
    bioSaved: 'Biografía guardada exitosamente',
    bioSaveError: 'Error al guardar la biografía',
    fullName: 'Nombre Completo',
    noName: 'Nombre no establecido',
    nameSaved: 'Nombre guardado exitosamente',
    nameSaveError: 'Error al guardar el nombre',
    certifications: 'Certificaciones',
    noCertifications: 'Aún no se han añadido certificaciones.',
    addCertification: 'Añadir Certificación',
    certificationName: 'Nombre de la Certificación',
    expiryDate: 'Fecha de Vencimiento',
    uploadDocument: 'Subir Documento',
    certificationAdded: 'Certificación añadida exitosamente',
    certificationAddError: 'Error al añadir la certificación',
    certificationRemoved: 'Certificación eliminada exitosamente',
    certificationRemoveError: 'Error al eliminar la certificación',
    expired: 'Vencido',
    expiresOn: 'Vence el',
    deletePicture: 'Eliminar Foto',
    pictureUploaded: 'Foto de perfil subida exitosamente',
    pictureUploadError: 'Error al subir la foto de perfil',
    pictureDeleted: 'Foto de perfil eliminada exitosamente',
    pictureDeleteError: 'Error al eliminar la foto de perfil',
    memberSince: 'Miembro desde',
    totalPilotHours: 'Horas de Vuelo Totales como Piloto',
  },

  auth: {
    signIn: 'Iniciar sesión',
    signOut: 'Cerrar sesión',
    signingOut: 'Cerrando sesión...',
    loginSuccessful: 'Inicio de sesión exitoso',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    fullName: 'Nombre completo',
    forgotPassword: '¿Olvidaste tu contraseña?',
    backToLogin: 'Volver al inicio de sesión',
    authenticationRequired: 'Autenticación requerida',
    invitationOnly:
      'El acceso es solo por invitación. Pida a un administrador de su organización que le invite.',
    emailRequired: 'El correo electrónico es requerido',
    emailInvalid: 'Por favor ingresa un correo electrónico válido',
    passwordRequired: 'La contraseña es requerida',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    fullNameRequired: 'El nombre completo es requerido',
    pendingApproval:
      'Tu cuenta está pendiente de aprobación. Por favor contacta a un administrador para ser asignado a una organización antes de poder iniciar sesión.',
  },

  passwordReset: {
    title: 'Restablecer contraseña',
    verifyCode: 'Verificar código',
    setNewPassword: 'Establecer nueva contraseña',
    emailPrompt: 'Ingresa tu correo electrónico y te enviaremos un código de verificación.',
    codeSentTo: 'Ingresa el código de 6 dígitos enviado a {{email}}',
    newPasswordPrompt: 'Ingresa tu nueva contraseña a continuación.',
    sendVerificationCode: 'Enviar código de verificación',
    verificationCode: 'Código de verificación',
    codeHelperText: 'Ingresa el código de 6 dígitos de tu correo electrónico',
    verifyCodeButton: 'Verificar código',
    resendCode: 'Reenviar código',
    resendCodeIn: 'Reenviar código en {{seconds}}s',
    changeEmail: 'Cambiar correo electrónico',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    passwordHelperText: 'Debe tener al menos 6 caracteres',
    resetPasswordButton: 'Restablecer contraseña',
    updatingPassword: 'Actualizando contraseña...',
    successTitle: '¡Contraseña restablecida exitosamente!',
    successMessage:
      'Tu contraseña ha sido actualizada exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.',
    redirecting: 'Serás redirigido a la página de inicio de sesión en breve...',
    processUpdatedTitle: 'Proceso de restablecimiento actualizado',
    processUpdatedMessage:
      'Nuestro proceso de restablecimiento de contraseña ha sido actualizado. Ahora usamos códigos de verificación en lugar de enlaces mágicos para mayor seguridad y compatibilidad.',
    instructionsTitle: 'Para restablecer tu contraseña:',
    instruction1: 'Haz clic en el botón de abajo para ir a la página de restablecimiento',
    instruction2: 'Ingresa tu correo electrónico',
    instruction3: 'Ingresa el código de verificación de 6 dígitos enviado a tu correo',
    instruction4: 'Establece tu nueva contraseña',
    goToPasswordReset: 'Ir a restablecer contraseña',
    autoRedirect: 'Serás redirigido automáticamente en 5 segundos...',
    codeRequired: 'El código de verificación es requerido',
    codeMustBe6Digits: 'El código de verificación debe tener 6 dígitos',
    invalidCode: 'Código de verificación inválido o expirado',
    codeSent: 'Código de verificación enviado a tu correo electrónico.',
    codeResent: 'Código de verificación reenviado a tu correo electrónico.',
    codeVerified: '¡Código verificado exitosamente!',
    passwordUpdated: '¡Contraseña actualizada exitosamente!',
  },

  invitation: {
    validating: 'Validando invitación...',
    invalidTitle: 'Invitación inválida',
    invalidMessage:
      'Esta invitación puede haber expirado o ya fue utilizada. Por favor contacta al administrador de tu organización para solicitar una nueva invitación.',
    goToLogin: 'Ir al inicio de sesión',
    acceptTitle: 'Aceptar invitación',
    invitedTo: 'Has sido invitado a unirte a {{organization}}',
    enterFullName: 'Ingresa tu nombre completo',
    createAccountButton: 'Crear cuenta y unirse a la organización',
    creatingAccount: 'Creando cuenta...',
    successTitle: '¡Cuenta creada exitosamente!',
    accountCreated: 'Cuenta creada exitosamente. Ya puedes iniciar sesión.',
    welcomeMessage:
      '¡Bienvenido a {{organization}}! Tu cuenta está lista. Serás redirigido a la página de inicio de sesión en breve.',
    redirectingToLogin: 'Serás redirigido a la página de inicio de sesión en breve...',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    signInHere: 'Inicia sesión aquí',
    noToken: 'No se proporcionó token de invitación',
    invalidData: 'Datos de invitación inválidos',
    userCreationFailed:
      'Cuenta creada pero no se devolvió el ID de usuario. Por favor intente iniciar sesión.',
  },

  noOrganization: {
    title: 'Cuenta pendiente de aprobación',
    message:
      '¡Tu cuenta ha sido creada exitosamente! Por favor contacta a un administrador para ser asignado a una organización antes de poder acceder al panel de mantenimiento.',
    loggedInAs: 'Conectado como: {{email}}',
  },

  header: {
    plotFlightData: 'Graficar datos de vuelo',
    adminTools: 'Herramientas de administración',
  },

  tabs: {
    overview: 'Resumen',
    files: 'Archivos',
    profile: 'Perfil',
    maintenance: 'Mantenimiento',
    healthPanel: 'Panel de salud',
    inventory: 'Inventario',
    calendar: 'Calendario',
  },

  filterDialog: {
    fileFilters: 'Filtros de archivos',
    droneSerial: 'Serial del dron',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    resetFileFilters: 'Restablecer filtros de archivos',
    sortOptions: 'Opciones de ordenamiento',
    sortBy: 'Ordenar por',
    sortByName: 'Nombre',
    sortByDate: 'Fecha',
    sortBySerial: 'Serial del dron',
    ascending: 'Asc',
    descending: 'Desc',
  },

  overview: {
    fleetOverview: 'Resumen de la flota',
    fleetSummary: 'Resumen de la flota',
    totalDrones: 'Total de drones',
    totalEngineHours: 'Total horas de motor',
    totalFlightHours: 'Total horas de vuelo',
    allDrones: 'Todos los drones',
    clickToViewProfile: 'Haz clic en cualquier tarjeta de dron para ver el perfil',
    noDronesFound: 'No se encontraron drones para tu organización',
    latestFlights: 'Últimos vuelos',
    noFlightsRecorded: 'Aún no se han registrado vuelos',
    failedToLoadFlights: 'No se pudieron cargar los últimos vuelos',
    drone: 'Dron',
    maintenance: 'Mantenimiento',
    flightHours: 'Horas de vuelo',
    engineHours: 'Horas de motor',
    overdue: 'VENCIDO: {{hours}}h',
    next: 'Siguiente: {{hours}}h',
    personnel: {
      title: 'Resumen del personal',
      pilots: 'Pilotos',
      maintenanceEngineers: 'Ingenieros de mantenimiento',
      noPilots: 'No se encontraron pilotos en tu organización',
      noMaintenanceEngineers: 'No se encontraron ingenieros de mantenimiento en tu organización',
      unnamed: 'Sin nombre',
      roles: {
        pilot: 'Piloto',
        maintenance: 'Mantenimiento',
      },
    },
  },

  droneStatus: {
    airworthy: 'Aeronavegable',
    airworthyTooltip: 'El dron está aeronavegable y listo para operaciones',
    airworthyWithLimitations: 'Aeronavegable con limitaciones',
    airworthyWithLimitationsTooltip:
      'El dron está aeronavegable pero tiene limitaciones operativas',
    maintenance: 'Mantenimiento',
    maintenanceTooltip: 'El dron está actualmente en mantenimiento',
    notAirworthy: 'No aeronavegable',
    notAirworthyTooltip: 'El dron no está aeronavegable y no puede ser operado',
    withCustomer: 'Con cliente',
    withCustomerTooltip: 'El dron está actualmente con un cliente',
    inProduction: 'En producción',
    inProductionTooltip: 'El dron se está fabricando o montando y aún no está en servicio',
    failedToUpdate: 'No se pudo actualizar el estado del dron',
  },

  // Drone Picture
  dronePicture: {
    failedToUpload: 'No se pudo cargar la imagen del dron',
  },

  profileTab: {
    selectDrone: 'Selecciona un dron para ver estadísticas',
    droneInformation: 'Información del dron',
    plotData: 'Graficar datos',
    totalFiles: 'Total de archivos',
    firstFlight: 'Primer vuelo',
    firstEngineRun: 'Primera ejecución del motor',
    engineStarts: 'Arranques del motor',
    engineHours: 'Horas de motor',
    flightHours: 'Horas de vuelo',
    // #1612: the definition shown under the figure on the drone page.
    flightHoursDefinition:
      'Tiempo en el aire, según la señal de vuelo del registrador (rpm del generador por encima de 5.100 donde un registro no la tiene).',
    hoursBreakdown: '({{tracked}} registradas + {{legacy}} históricas)',
    droneStatusLabel: 'Estado del dron',
    statusUpdated: 'Estado del dron actualizado a {{status}}',
    invalidDate: 'Fecha inválida',
    ownershipLabel: 'Propiedad',
    ownershipSold: 'Vendido',
    ownershipLeased: 'Arrendado',
    leaseEnds: 'finaliza',
    failedToLoadStatus: 'Error al cargar el estado del dron',
  },

  dronePageShared: {
    sharedBy: 'Compartido por {{org}}',
    sharedByUnknown: 'Compartido por otra organización',
    countersIncludeSharedOne: 'Incluye {{count}} vuelo compartido por {{orgs}}',
    countersIncludeSharedOther: 'Incluye {{count}} vuelos compartidos por {{orgs}}',
    timelineShared: 'Incluye vuelos compartidos: {{orgs}}',
    trendPointShared: 'Compartido por {{org}}',
  },

  technicalSpecs: {
    title: 'Especificaciones técnicas',
    subtitle: 'Configuración, Software, Números de serie y Opciones',
    configuration: 'Configuración',
    software: 'Software',
    serialNumbers: 'Números de serie',
    options: 'Opciones',
    updatedSuccessfully: '{{field}} actualizado exitosamente',
    failedToUpdate: 'No se pudo actualizar la especificación técnica',
    tempSensorCableClip: 'Clip de fijación del cable del sensor de temperatura',
    notSet: 'Sin definir',
  },

  notes: {
    title: 'Notas',
    notesFor: 'Notas para {{serial}}',
    summary: '{{total}} total • {{unresolved}} sin resolver • {{resolved}} resueltas',
    filters: 'Filtros',
    createNote: 'Crear nota',
    search: 'Buscar',
    type: 'Tipo',
    allTypes: 'Todos los tipos',
    general: 'General',
    customerFeedback: 'Comentarios del cliente',
    alert: 'Alerta',
    priority: 'Prioridad',
    allPriorities: 'Todas las prioridades',
    information: 'Información',
    critical: 'Crítico',
    includeResolved: 'Incluir resueltas',
    selectDroneToView: 'Selecciona un dron para ver notas',
    noNotesFound: 'No se encontraron notas',
    createFirstNote: 'Crea tu primera nota',
    addNote: 'agregar nota',
    failedToLoad: 'No se pudieron cargar las notas',
    failedToCreate: 'No se pudo crear la nota',
    failedToUpdate: 'No se pudo actualizar la nota',
    failedToDelete: 'No se pudo eliminar la nota',
    failedToResolve: 'No se pudo resolver la nota',
    failedToUnresolve: 'No se pudo reabrir la nota',
  },

  maintenanceTab: {
    selectDrone: 'Selecciona un dron para ver registros de mantenimiento',
    upcomingMaintenance: 'Mantenimiento próximo',
    addMaintenance: 'Agregar mantenimiento',
    maintenanceHistory: 'Historial de mantenimiento',
    componentMaintenanceSchedule: 'Programa de mantenimiento de componentes',
    visualInspectionSchedule: 'Programa de inspección visual',
    noUpcoming: 'No hay mantenimiento próximo programado',
    noHistory: 'No hay historial de mantenimiento disponible',

    // Schedule card
    overdue: 'VENCIDO',
    dueIn: 'Vence en:',
    hrsOverdue: '{{hours}} hrs vencidas',
    hrs: '{{hours}} hrs',
    trackingOnly: 'Solo seguimiento',
    hrsAccumulated: '{{hours}} hrs acumuladas',
    viewMaintenanceManual: 'Ver manual de mantenimiento',
    viewInspectionInstructions: 'Ver instrucciones de inspección',

    // Historical/Record card
    performedBy: 'Realizado por:',
    addedBy: 'Agregado por:',
    reviewedBy: 'Revisado por:',
    qualityChecked: 'Calidad verificada',
    workOrderId: 'ID de orden de trabajo:',
    unknown: 'Desconocido',

    // Record statuses
    statusCompleted: 'Completado',
    statusCancelled: 'Cancelado',
    statusPending: 'Pendiente',

    // View dialog
    workDescription: 'Descripción del trabajo',
    qualityCheckedBy: 'Calidad verificada por:',
    deleteMaintenanceRecord: 'Eliminar registro de mantenimiento',
    deleteConfirmMessage: '¿Estás seguro de que deseas eliminar este registro de mantenimiento?',
    deleteRecalculationWarning:
      'Esta acción activará el recálculo automático de los contadores de mantenimiento del dron',
    deleteSuccess: 'Registro de mantenimiento eliminado exitosamente',
    deleteFailed: 'Error al eliminar el registro de mantenimiento. Por favor intenta de nuevo.',

    // Record form
    startDate: 'Fecha de inicio:',
    endDate: 'Fecha de fin:',
    startDateLabel: 'Fecha de inicio',
    endDateLabel: 'Fecha de fin',
    maintenancePerformed: 'Mantenimiento realizado',
    unknownUser: 'Usuario desconocido',
    differentUserRequired: '(Se requiere otro usuario)',
    failedToOpenManual: 'No se pudo abrir el manual de mantenimiento',
    failedToLoadTimeline: 'No se pudo cargar la línea de tiempo de mantenimiento',
    failedToDownloadAttachment: 'No se pudo descargar el archivo adjunto de mantenimiento',
  },

  // Statistics mutations
  statistics: {
    failedToFetchWeather: 'No se pudieron obtener los datos meteorológicos',
    failedToUpdateFlight: 'No se pudo actualizar los metadatos del vuelo',
    failedToUploadAttachment: 'No se pudo cargar el archivo adjunto',
  },

  filesTab: {
    title: 'Archivos',
    uploadFile: 'Subir archivo',
    noFiles: 'No se encontraron archivos',
    fileName: 'Nombre del archivo',
    fileSize: 'Tamaño',
    uploadedBy: 'Subido por',
    uploadedAt: 'Subido el',
    downloadFile: 'Descargar archivo',
    deleteFile: 'Eliminar archivo',
    confirmDelete: '¿Estás seguro de que deseas eliminar este archivo?',
  },

  fileManagement: {
    title: 'Gestión de archivos',
    root: 'Raíz',
    sharedFolderChip: 'Compartido contigo',
    backToShared: 'Volver a Compartido',
    folderNotFoundTitle: 'Carpeta no encontrada',
    folderNotFoundBody:
      'Este enlace no lleva a ninguna carpeta que pueda abrir. Es posible que se haya eliminado o que nunca se haya compartido con su organización.',
    notAFolderTitle: 'Ese enlace apunta a un archivo',
    notAFolderBody:
      'Los enlaces de carpeta abren una carpeta. Este nombra un archivo, así que no hay nada que listar: ábralo desde la carpeta en la que está.',
    backToMyFiles: 'Volver a mis archivos',
    folderFileCount: '{{count}} archivos',
    folderSerial: 'Dron {{serial}}',
    showingOfTotal: 'Mostrando {{shown}} de {{total}}',
    newFolder: 'Nueva carpeta',
    uploadFiles: 'Subir archivos',
    hideUpload: 'Ocultar subida',
    documents: 'Documentos',
    reports: 'Informes',
    noFilesInDirectory: 'No se encontraron archivos en este directorio',
    moreActions: 'Más acciones',
    download: 'Descargar',
    downloadMany: 'Descargar ({{count}} archivos)',
    bulkDownloadProgress: 'Descargando {{done}} de {{total}}...',
    bulkDownloadBrowserHint:
      'Es posible que su navegador pregunte una vez si este sitio puede descargar varios archivos.',
    bulkDownloadDone: '{{count}} descargas iniciadas.',
    bulkDownloadPartial: '{{started}} de {{total}} descargas iniciadas. No descargados: {{names}}',
    rename: 'Renombrar',
    move: 'Mover',
    delete: 'Eliminar',
    plot: 'Graficar',
    details: 'Detalles',
    moving: 'Moviendo: {{fileName}}',
    moveInstructions: 'Navega a la carpeta de destino y haz clic en "Mover aquí"',
    moveHere: 'Mover aquí',
    createNewFolder: 'Crear nueva carpeta',
    folderName: 'Nombre de carpeta',
    folderNameInvalidDots: "El nombre de carpeta no puede contener '..' (riesgo de seguridad)",
    folderNameInvalidStart: 'El nombre de carpeta no puede empezar con separadores de ruta',
    folderNameInvalidSlash: "El nombre de carpeta no puede contener barras diagonales ('/')",

    // Rename folder dialog
    renameFolderTitle: 'Renombrar carpeta',
    newFolderName: 'Nuevo nombre de carpeta',

    uploadingTo: 'Subiendo a: {{path}}',
    flightAnalysisResults: 'Resultados del análisis de vuelo',
    rowsProcessed: 'Filas procesadas',
    columnsProcessed: 'Columnas procesadas',
    extractedMetadata: 'Metadatos extraídos',
    dropFilesHere: 'Suelta los archivos aquí',
    dragAndDropFiles: 'Arrastra y suelta archivos aquí',
    orClickToBrowse: 'o haz clic para buscar archivos',
    allowedFilesInfo: 'Permitidos: {{types}} (Máx: {{maxFiles}} archivos)',
    selectedFiles: 'Archivos seleccionados ({{count}})',
    analyze: 'Analizar',
    remove: 'Eliminar',
    uploadingProgress: 'Subiendo... {{progress}}%',
    clearAll: 'Limpiar todo',
    uploadSettings: 'Configuración de subida',
    destination: 'Destino:',
    destinationHelp:
      'Los archivos se subirán a la carpeta que estás navegando actualmente. Navega a tu carpeta de destino antes de subir.',
    flightTypeRequired: 'Tipo de vuelo *',
    loadingFlightTypes: 'Cargando tipos de vuelo...',
    selectFlightType: 'Seleccionar tipo de vuelo',
    payloadRequired: 'Carga útil *',
    loadingPayloads: 'Cargando cargas útiles...',
    selectPayload: 'Seleccionar carga útil',
    pilotRequired: 'Piloto *',
    loadingPilots: 'Cargando pilotos...',
    selectPilot: 'Seleccionar piloto',
    customer: 'Cliente',
    loadingCustomers: 'Cargando clientes...',
    selectCustomer: 'Seleccionar cliente',
    addCustomer: 'Añadir nuevo cliente',
    addNewCustomer: 'Añadir nuevo cliente',
    customerName: 'Nombre del cliente',
    customerAdded: 'Cliente añadido con éxito',
    failedToAddCustomer: 'Error al añadir el cliente',
    project: 'Proyecto',
    loadingProjects: 'Cargando proyectos...',
    selectProject: 'Seleccionar proyecto',
    addProject: 'Añadir nuevo proyecto',
    addNewProject: 'Añadir nuevo proyecto',
    projectName: 'Nombre del proyecto',
    projectAdded: 'Proyecto añadido con éxito',
    failedToAddProject: 'Error al añadir el proyecto',
    addPayload: 'Añadir nueva carga útil',
    addNewPayload: 'Añadir nueva carga útil',
    payloadName: 'Nombre de carga útil',
    payloadWeight: 'Peso (kg)',
    payloadAdded: 'Carga útil añadida con éxito',
    failedToAddPayload: 'Error al añadir la carga útil',
    airspaceObserver: 'Observador del espacio aéreo',
    loadingAirspaceObservers: 'Cargando observadores del espacio aéreo...',
    selectAirspaceObserver: 'Seleccionar observador del espacio aéreo',
    payloadOperator: 'Operador de carga útil',
    loadingPayloadOperators: 'Cargando operadores de carga útil...',
    selectPayloadOperator: 'Seleccionar operador de carga útil',
    flightTypePayloadRequired:
      'Tipo de vuelo y carga útil son requeridos para archivos CSV de datos de vuelo',
    flightTypePayloadPilotRequired:
      'Tipo de vuelo, carga útil y piloto son requeridos para archivos CSV de datos de vuelo',
    documentFilesInfo:
      'Los archivos de documento se subirán directamente - no se requieren metadatos de vuelo',
    testModeLabel: 'Subir como datos de prueba (omitir validación)',
    filesToUpload: 'Archivos a subir:',
    uploadCount: 'Subir {{count}} archivo(s)',
    uploadSuccess: '{{count}} archivo(s) subido(s) exitosamente',
    fileAnalyzed: 'Archivo analizado exitosamente',
    fileDeleted: 'Archivo eliminado exitosamente',
    folderDeleted: 'Carpeta eliminada exitosamente',
    folderCreated: 'Carpeta creada exitosamente',
    fileMoved: 'Archivo movido exitosamente',
    itemsMoved: '{{count}} elemento(s) movido(s) correctamente',
    itemsMovedPartial: '{{moved}} movido(s), {{failed}} fallido(s): {{names}}',
    folderMoved: 'Carpeta movida exitosamente',
    folderRenamed: 'Carpeta renombrada exitosamente',
    downloadStarted: 'Descarga iniciada',
    includeUntaggedData: 'Incluir datos sin etiquetar',
    failedToLoadFiles: 'Error al cargar archivos',
    failedToUpload: 'Error en la subida',
    failedToAnalyze: 'Error en el análisis',
    failedToDownload: 'Error en la descarga',
    failedToDelete: 'Error al eliminar archivo',
    failedToDeleteFolder: 'Error al eliminar carpeta',
    failedToMove: 'Error al mover elemento',
    failedToCreateFolder: 'Error al crear carpeta',
    failedToRenameFolder: 'Error al renombrar carpeta',
    failedToGenerateUrl: 'Error al generar URL de descarga',
    cannotMoveToSameLocation: 'No se puede mover el elemento a la misma ubicación',
    maxFilesAllowed: 'Máximo {{count}} archivos permitidos',
    invalidFileTypes: 'Tipos de archivo inválidos. Permitidos: {{types}}',
    selectFilesToUpload: 'Por favor selecciona archivos para subir',
    selectFlightTypeForCsv: 'Por favor selecciona un tipo de vuelo para archivos CSV',
    selectPayloadForCsv: 'Por favor selecciona una carga útil para archivos CSV',
    selectPilotForCsv: 'Por favor selecciona un piloto para archivos CSV',
    failedToLoadData:
      'Error al cargar tipos de vuelo, cargas útiles y pilotos. Por favor intenta de nuevo.',
    analysisCompleted: 'Análisis completado para {{fileName}}',
    testData: 'Datos de prueba',
    unknownFile: 'Archivo desconocido',

    // Duplicate file handling
    duplicateFilesSkipped: 'Archivos duplicados omitidos',
    duplicateFilesMessage: 'Los siguientes {{count}} archivo(s) fueron omitidos porque ya existen:',
  },

  // Flight Reports
  reports: {
    title: 'Informes de Vuelo',
    backToFiles: '← Volver a Archivos',
    generateReport: 'Generar Informe',
    noReports: 'Sin Informes Aún',
    generateFirstReport: 'Genere su primer informe de horas de vuelo',

    // Loading/Error states
    failedToLoad: 'Error al cargar informes',
    failedToGenerateUrl: 'Error al generar URL de descarga',
    failedToDownload: 'Error al descargar informe',
    failedToDelete: 'Error al eliminar informe',
    failedToLoadFilters: 'Error al cargar opciones de filtro',

    // Actions
    confirmDelete: '¿Está seguro de que desea eliminar "{{title}}"?',
    deleteSuccess: 'Informe "{{title}}" eliminado exitosamente',
    deleteFailed: 'Error al eliminar informe',
    moreActions: 'Más acciones',
    download: 'Descargar',
    delete: 'Eliminar',
    downloadStarted: 'Descarga iniciada para "{{title}}"',

    // Generation dialog
    generateReportTitle: 'Generar Informe de Horas de Vuelo',
    reportTitle: 'Título del Informe',
    titlePlaceholder: 'ej., Resumen de Vuelo Q4 2025',
    titleRequired: 'El título del informe es requerido',
    datesRequired: 'Las fechas de inicio y fin son requeridas',
    invalidDateRange: 'La fecha de inicio debe ser anterior a la fecha de fin',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    selectDrones: 'Seleccionar Drones',
    allDrones: 'Todos los Drones',
    selectPayloads: 'Seleccionar Cargas Útiles',
    allPayloads: 'Todas las Cargas Útiles',
    selectPilots: 'Seleccionar Pilotos',
    allPilots: 'Todos los Pilotos',
    leaveEmptyForAll: 'Dejar vacío para incluir todos',
    includeIncidents: 'Incidentes/Accidentes',
    generate: 'Generar Informe',
    generateSuccess: 'Informe generado exitosamente',
    generateFailed: 'Error al generar informe',

    // Content type selection
    includeInReport: 'Incluir en el Informe',
    includeFlightHours: 'Horas de Vuelo',
    includeMaintenanceData: 'Datos de Mantenimiento',
    selectAtLeastOne: 'Seleccione al menos un tipo de contenido para incluir en el informe',

    // Maintenance filters
    maintenanceTypes: 'Tipos de Mantenimiento',
    allMaintenanceTypes: 'Todos los Tipos de Mantenimiento',
    maintenanceTypesHelper: 'Dejar vacío para incluir todos los tipos de mantenimiento',
  },

  healthPanel: {
    title: 'Panel de salud',
    selectDrone: 'Selecciona un dron para ver el panel de salud',
    systemHealth: 'Salud del sistema',
    lastUpdated: 'Última actualización',
    noData: 'No hay datos de salud disponibles',

    // Panel titles
    engineStartup: 'Arranque del motor',
    performance: 'Rendimiento',
    cooling: 'Enfriamiento',
    batteries: 'Baterías',
    fuelSystem: 'Sistema de combustible',
    liftSystem: 'Sistema de elevación',

    // Panel info content
    performanceInfo:
      'Rango normal: 80-100%. Tendencia calculada por regresión lineal en datos de vuelo históricos.',
    coolingInfo:
      'Rango normal: 0-125°C. Tendencia calculada por regresión lineal en datos de vuelo históricos.',

    // Analysis displays
    latest: 'Último {{title}}:',
    trend: 'Tendencia:',
    forecast: 'Pronóstico:',
    forecastBy: 'para {{date}}',
    rSquared: '(R² = {{value}})',
    insufficientData:
      'Datos insuficientes para análisis de tendencia (se necesitan al menos 3 puntos de datos)',

    // Click-a-point formula popup
    pointFormula: 'Fórmula',
    pointValues: 'Valores de este vuelo',
    pointNoSources: 'No se guardaron los valores de origen de este vuelo.',
    pointNoFormula: 'No hay detalles de fórmula para esta métrica.',

    // Status labels
    statusNormal: 'NORMAL',
    statusWarning: 'ADVERTENCIA',
    statusUnknown: 'DESCONOCIDO',
    outOfBandFlights: '{{count}} de {{total}} vuelos representados fuera del rango aceptable',

    // TUWT display
    warningTime: 'Tiempo de advertencia',
    errorTime: 'Tiempo de error',
    ofTotal: '({{percentage}}% del total)',
    totalMonitoringTime: 'Tiempo total de monitoreo:',

    // Trend labels
    trendImproving: 'MEJORANDO',
    trendWorsening: 'EMPEORANDO',
    trendStable: 'ESTABLE',
    trendLabel: 'Tendencia: {{trend}}',
  },

  admin: {
    title: 'Herramientas de administración',
    droneManagement: 'Gestión de drones',
    userManagement: 'Gestión de usuarios',
    organizationManagement: 'Gestión de organizaciones',
    announcements: 'Anuncios',
    inviteUser: 'Invitar usuario',
    createDrone: 'Crear dron',
    createOrganization: 'Crear organización',
    createAnnouncement: 'Crear anuncio',
    users: 'Usuarios',
    userName: 'Nombre',
    userEmail: 'Correo electrónico',
    userRole: 'Rol',
    userOrganization: 'Organización',
    userStatus: 'Estado',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    assignOrganization: 'Asignar organización',
    roleAdmin: 'Administrador',
    roleUser: 'Usuario',
    roleMaintainer: 'Mantenedor',
    drones: 'Drones',
    droneSerial: 'Número de serie',
    droneOrganization: 'Organización',
    editDrone: 'Editar dron',
    deleteDrone: 'Eliminar dron',
    organizations: 'Organizaciones',
    orgName: 'Nombre',
    orgSlug: 'Slug',
    editOrganization: 'Editar organización',
    deleteOrganization: 'Eliminar organización',
    announcementTitle: 'Título',
    announcementContent: 'Contenido',
    announcementPriority: 'Prioridad',
    priorityLow: 'Baja',
    priorityMedium: 'Media',
    priorityHigh: 'Alta',
    editAnnouncement: 'Editar anuncio',
    deleteAnnouncement: 'Eliminar anuncio',
  },

  inviteDialog: {
    title: 'Invitar usuario',
    emailLabel: 'Dirección de correo electrónico',
    emailPlaceholder: 'Ingresa la dirección de correo electrónico',
    roleLabel: 'Rol',
    sendInvitation: 'Enviar invitación',
    sending: 'Enviando...',
    successMessage: 'Invitación enviada exitosamente a {{email}}',
    errorMessage: 'Error al enviar la invitación',
  },

  inbox: {
    title: 'Bandeja de entrada',
    noMessages: 'Sin mensajes',
    markAsRead: 'Marcar como leído',
    markAllAsRead: 'Marcar todo como leído',
    delete: 'Eliminar',
    failedToLoad: 'No se pudieron cargar los anuncios',
    failedToMarkRead: 'No se pudo marcar el anuncio como leído',
    failedToDownloadAttachment: 'No se pudo descargar el archivo adjunto',
  },

  documents: {
    title: 'Documentos',
    backToFiles: '← Volver a Archivos',
    uploadDocument: 'Subir Documento',
    noDocuments: 'No se encontraron documentos',
    uploadFirstDocument: 'Sube tu primer documento para comenzar',
    moreActions: 'Más acciones',
    download: 'Descargar',
    delete: 'Eliminar',
    validUntil: 'Válido hasta:',

    typeInsurance: 'Seguro',
    typePermit: 'Permiso',
    typeOther: 'Otro',

    selectFile: 'Seleccionar Archivo',
    titleLabel: 'Título',
    descriptionLabel: 'Descripción',
    documentType: 'Tipo de Documento',
    validityStartDate: 'Fecha de Inicio de Validez (Opcional)',
    validityEndDate: 'Fecha de Fin de Validez (Opcional)',

    titleRequired: 'El título es requerido',
    pleaseSelectFile: 'Por favor selecciona un archivo',
    startDateBeforeEnd: 'La fecha de inicio debe ser anterior a la fecha de fin',

    uploadSuccess: 'Documento subido exitosamente',
    uploadFailed: 'Error al subir',
    downloadedDocument: '{{title}} descargado',
    failedToGenerateUrl: 'Error al generar URL de descarga',
    failedToDownload: 'Error al descargar documento',
    confirmDelete: '¿Estás seguro de que deseas eliminar "{{title}}"?',
    deleteSuccess: 'Documento {{title}} eliminado exitosamente',
    deleteFailed: 'Error al eliminar',
    failedToDelete: 'Error al eliminar documento',
    failedToLoad: 'Error al cargar documentos',
    failedToUpload: 'Error al subir documento',
  },

  sessionTimeout: {
    title: 'Tiempo de sesión agotado',
    message: 'Tu sesión está a punto de expirar por inactividad.',
    stayLoggedIn: 'Mantener sesión',
    logout: 'Cerrar sesión',
    expiresIn: 'La sesión expira en {{seconds}} segundos',
  },

  chat: {
    title: 'Chat',
    placeholder: 'Escribe un mensaje...',
    send: 'Enviar',
    minimize: 'Minimizar',
    close: 'Cerrar chat',
    failedToLoadPageImage: 'No se pudo cargar la imagen de la página',
  },

  errors: {
    generic: 'Ocurrió un error. Por favor intenta de nuevo.',
    networkError: 'Error de red. Por favor verifica tu conexión.',
    unauthorized: 'No estás autorizado para realizar esta acción.',
    notFound: 'El recurso solicitado no fue encontrado.',
    serverError: 'Error del servidor. Por favor intenta más tarde.',
    validationError: 'Por favor verifica tu entrada e intenta de nuevo.',
    sessionExpired: 'Tu sesión ha expirado. Por favor inicia sesión de nuevo.',
    failedToLoad: 'Error al cargar datos. Por favor intenta de nuevo.',
    failedToSave: 'Error al guardar cambios. Por favor intenta de nuevo.',
    failedToDelete: 'Error al eliminar. Por favor intenta de nuevo.',
  },

  // Admin Tools Page
  adminToolsPage: {
    // Page header
    title: 'Herramientas de Admin',
    subtitle: 'Herramientas y utilidades de administrador',
    backToDashboard: 'Volver al Panel',

    // Access denied
    accessDenied: 'Acceso Denegado',
    adminOnlyMessage: 'Esta página solo es accesible para administradores.',
    returnToDashboard: 'Volver al Panel',

    // Common labels
    xerAdminOnly: 'Solo Admin XER',
    users: 'Usuarios',
    close: 'Cerrar',
    cancel: 'Cancelar',
    assign: 'Asignar',

    // Roles
    roles: {
      admin: 'Admin',
      adminDesc: 'Acceso completo al sistema',
      pilot: 'Piloto',
      pilotDesc: 'Operaciones de vuelo',
      maintenance: 'Mantenimiento',
      maintenanceDesc: 'Operaciones de mantenimiento',
      airspaceObserver: 'Observador de Espacio Aéreo',
      airspaceObserverDesc: 'Solo monitoreo',
      noRolesAssigned: 'Sin roles asignados',
    },

    // Metadata Extraction Card
    metadataExtraction: {
      title: 'Re-ejecutar Extracción de Metadatos',
      description:
        'Re-procesar archivos CSV para extraer metadatos actualizados usando el último extractor de metadatos XER. Esto actualiza los datos de vuelo en la base de datos.',
      processingScope: 'Alcance del procesamiento:',
      xerOnly: 'Solo XER Technologies',
      allOrganizations: 'TODAS las organizaciones',
      extractingFiles: 'Extrayendo metadatos de archivos CSV... ({{current}}/{{total}} archivos)',
      startedBy: 'Iniciado por: {{user}} a las {{time}}',
      processingNote:
        'Este proceso puede tomar varios minutos para colecciones grandes de archivos.',
      processingInProgress: 'Procesamiento en progreso...',
      successMessage: 'Procesados exitosamente {{processed}}/{{total}} archivos CSV',
      failedMessage: '{{message}}',
      filesFailed: '{{count}} archivos fallaron al procesar',
      completedIn: 'Completado en {{seconds}} segundos',
      s3Modified: '{{count}} archivos S3 modificados con datos CSV mejorados',
      detailedLog: 'Registro detallado:',
      download: 'Descargar',
      failedFiles: 'Archivos fallidos:',
      andMore: '... y {{count}} más',
      jobRunning: 'Tarea ejecutándose...',
      processing: 'Procesando...',
      startGlobalReExtraction: 'Iniciar Extracción Global',
      startReExtraction: 'Iniciar Extracción',
    },

    // Add Drone Card
    addDrone: {
      title: 'Agregar Nuevo Dron a la Base de Datos',
      description:
        'Agregar un nuevo número de serie de dron a la base de datos. Esto permite cargas de datos de vuelo para ese dron. Los drones se asignan automáticamente a la organización XER Technologies.',
      buttonLabel: 'Agregar Nuevo Dron',
      dialogTitle: 'Agregar Nuevo Dron a la Base de Datos',
      serialNumber: 'Número de Serie *',
      serialNumberPlaceholder: 'Ingresar número de serie del dron',
      model: 'Modelo (Opcional)',
      modelPlaceholder: 'Ingresar modelo del dron',
      commissioningDate: 'Fecha de Puesta en Servicio (Opcional)',
      serialRequired: 'Se requiere número de serie',
      notes: {
        uniqueSerial: 'El número de serie es requerido y debe ser único',
        assignedToXer: 'El dron será asignado a la organización XER Technologies',
        activeByDefault: "El estado se establecerá en 'activo' por defecto",
      },
      adding: 'Agregando...',
      addDrone: 'Agregar Dron',
    },

    // User Management Card
    userManagement: {
      title: 'Gestión de Usuarios',
      description:
        'Ver todos los usuarios en tu organización y sus roles asignados. Monitorear acceso de usuarios y permisos en la plataforma.',
      viewUsers: 'Ver Usuarios',
      inviteUser: 'Invitar Usuario',
      tableHeaders: {
        name: 'Nombre',
        email: 'Correo',
        roles: 'Roles',
        joined: 'Ingresó',
        actions: 'Acciones',
      },
      noUsersFound: 'No se encontraron usuarios en esta organización.',
    },

    // Organization Management Card
    orgManagement: {
      title: 'Gestión de Organizaciones',
      description:
        'Ver y gestionar todas las organizaciones en el sistema. Monitorear configuraciones de organización y acceso en la plataforma.',
      viewOrganizations: 'Ver Organizaciones',
      createNewOrg: 'Crear Nueva Organización',
      unassignedUsers: 'Usuarios Sin Asignar ({{count}})',
      unassignedUsersWarning:
        'Estos usuarios se han registrado pero aún no están asignados a ninguna organización.',
      tableHeaders: {
        registered: 'Registrado',
        assignToOrg: 'Asignar a Organización',
        assignRoles: 'Asignar Roles',
        action: 'Acción',
        orgName: 'Nombre de Organización',
      },
      selectOrganization: 'Seleccionar Organización',
      noOrgsFound: 'No se encontraron organizaciones en el sistema.',
      createOrgDialog: {
        title: 'Crear Nueva Organización',
        orgName: 'Nombre de Organización *',
        orgNamePlaceholder: 'Ingresar nombre de organización',
        slug: 'Slug: {{slug}}',
        creating: 'Creando...',
        createOrg: 'Crear Organización',
      },
    },

    // Drone Assignments Card
    droneAssignments: {
      title: 'Asignaciones de Drones',
      description:
        'Gestionar asignaciones de drones a organizaciones. Reasignar drones entre organizaciones según sea necesario para flexibilidad operacional.',
      manageAssignments: 'Gestionar Asignaciones',
      dialogTitle: 'Asignaciones de Drones a Organizaciones',
      tableHeaders: {
        serialNumber: 'Número de Serie',
        currentOrg: 'Organización Actual',
        status: 'Estado',
        ownershipType: 'Tipo de propiedad',
        leaseEndDate: 'Fin de arrendamiento',
        actions: 'Acciones',
      },
      noOrgAssigned: 'Sin organización asignada',
      noDronesFound: 'No se encontraron drones en el sistema.',
      noOwnership: 'No definido',
    },

    // Maintenance Documents Card
    maintenanceDocs: {
      title: 'Documentos de Mantenimiento',
      description:
        'Gestionar documentación de mantenimiento para el agente IA. Cargar manuales, procedimientos, especificaciones de herramientas y diagramas para soporte inteligente de mantenimiento.',
      manageDocuments: 'Gestionar Documentos',
      dialogTitle: 'Gestión de Documentos de Mantenimiento',
      uploadSection: 'Cargar Nuevo Documento',
      selectPdfFile: 'Seleccionar Archivo PDF',
      selectedFile: 'Seleccionado: {{name}} ({{size}} MB)',
      documentTitle: 'Título del Documento *',
      documentType: 'Tipo de Documento *',
      docTypes: {
        manual: 'Manual',
        procedure: 'Procedimiento',
        toolSpec: 'Especificación de Herramienta',
        diagram: 'Diagrama',
        safety: 'Documento de Seguridad',
      },
      version: 'Versión (Opcional)',
      versionPlaceholder: 'v2.1, Rev 3, etc.',
      droneModel: 'Modelo de Dron (Opcional)',
      droneModelPlaceholder: 'DJI Mavic 3, etc.',
      manufacturer: 'Fabricante (Opcional)',
      manufacturerPlaceholder: 'DJI, Xer Technologies, etc.',
      uploading: 'Cargando...',
      uploadDocument: 'Cargar Documento',
      uploadedDocuments: 'Documentos Cargados',
      noDocsYet: 'No hay documentos cargados aún. Carga tu primer documento arriba.',
      tableHeaders: {
        title: 'Título',
        type: 'Tipo',
        size: 'Tamaño',
        status: 'Estado',
        uploaded: 'Cargado',
        actions: 'Acciones',
      },
      processed: 'Procesado ({{chunks}} fragmentos)',
      notProcessed: 'No Procesado',
      reprocessDoc: 'Reprocesar documento',
      processForAI: 'Procesar documento para agente IA',
      deleteDocument: 'Eliminar documento',
      confirmDelete: '¿Estás seguro de que quieres eliminar este documento?\n\nKey: {{key}}',
    },

    // Tender Emails Card
    tenderEmails: {
      title: 'Correos de Licitaciones',
      description:
        'Ver correos reenviados a Trent (el agente de licitaciones) y sus evaluaciones de IA. Monitorear la actividad del pipeline de licitaciones y reprocesar correos fallidos.',
      viewEmails: 'Ver Correos de Licitaciones',
      dialogTitle: 'Evaluaciones de Correos de Licitaciones',
      filterStatus: 'Estado',
      allStatuses: 'Todos',
      refresh: 'Actualizar',
      noEmails: 'No se encontraron correos de licitaciones.',
      tableHeaders: {
        subject: 'Asunto',
        from: 'De',
        status: 'Estado',
        evaluation: 'Evaluación',
        confidence: 'Confianza',
        date: 'Recibido',
        actions: 'Acciones',
      },
      reprocess: 'Reprocesar este correo',
      summary: 'Resumen',
      client: 'Cliente',
      deadline: 'Plazo',
      budget: 'Presupuesto',
      keyFactors: 'Factores Clave',
      reasoning: 'Análisis',
      replySent: 'Respuesta enviada',
      processedAt: 'Procesado',
      scrapedLinks: 'Enlaces Extraídos',
      attachments: 'Adjuntos',
      individualTenders: 'Licitaciones Individuales',
      tenderTitle: 'Licitación',
      pages: 'páginas',
    },

    // Announcements Card
    announcements: {
      title: 'Anuncios',
      description:
        'Enviar anuncios a toda la plataforma a usuarios y organizaciones. Rastrear entrega y estado de lectura para todos los mensajes enviados.',
      manageAnnouncements: 'Gestionar Anuncios',
      dialogTitle: 'Gestión de Anuncios',
      sendNew: 'Enviar Nuevo Anuncio',
      announcementTitle: 'Título *',
      messageBody: 'Cuerpo del Mensaje *',
      sendTo: 'Enviar A *',
      targetTypes: {
        allUsers: 'Todos los Usuarios de la Plataforma',
        specificOrgs: 'Organizaciones Específicas',
        specificUsers: 'Usuarios Específicos',
      },
      selectOrganizations: 'Seleccionar Organizaciones *',
      selectUsers: 'Seleccionar Usuarios *',
      attachFiles: 'Adjuntar Archivos (Opcional)',
      sendEmailNotification: 'También enviar notificación por correo',
      sending: 'Enviando...',
      sendAnnouncement: 'Enviar Anuncio',
      sentSuccess: '¡Anuncio enviado a {{count}} usuarios!',
      sentAnnouncements: 'Anuncios Enviados ({{count}})',
      tableHeaders: {
        title: 'Título',
        created: 'Creado',
        recipients: 'Destinatarios',
        readUnread: 'Leído / No Leído',
      },
      by: 'por {{name}}',
      read: '{{count}} leídos',
      unread: '{{count}} no leídos',
      noAnnouncementsYet: 'No hay anuncios enviados aún.',
    },

    // Maintenance Recalculate Card
    maintenanceRecalculate: {
      title: 'Recalcular Contadores de Mantenimiento',
      description:
        'Recalcular todos los contadores de mantenimiento de un dron desde cero. Reconstruye el historial de mantenimiento y corrige inconsistencias de datos.',
      buttonLabel: 'Recalcular Contadores',
      selectDrone: 'Seleccionar Dron',
      recalculate: 'Recalcular',
      recalculating: 'Recalculando...',
      infoText: 'Esto recalculará todos los contadores de mantenimiento desde cero. El sistema:',
      infoBullet1:
        'Reconstruirá el historial de mantenimiento a partir de todos los registros completados y verificados',
      infoBullet2:
        'Reiniciará todos los contadores de horas de vuelo y motor según el mantenimiento realizado',
      infoBullet3: 'Corregirá inconsistencias de datos',
      resultComplete: 'Recálculo Completado',
      resultSummary:
        '{{processed}} registros de mantenimiento procesados \u2022 {{reset}} contadores actualizados \u2022 {{unchanged}} sin cambios',
      viewDetails: 'Ver Detalles',
      hideDetails: 'Ocultar Detalles',
      totalFlightHours: 'Horas de Vuelo Totales',
      totalEngineHours: 'Horas de Motor Totales',
      countersBreakdown: 'Desglose de Contadores de Mantenimiento',
      tableCounter: 'Contador',
      tableLastMaintenance: 'Último Mantenimiento',
      tableFlightsSince: 'Vuelos Desde',
      tableTotalHours: 'Horas Totales',
      tableRemaining: 'Restante',
      flightHoursLabel: 'Horas de Vuelo',
      engineHoursLabel: 'Horas de Motor',
      byPerformer: 'por {{name}}',
      neverMaintained: 'Nunca mantenido',
      noFlights: 'Sin vuelos',
    },

    // Invite User Dialog
    inviteUser: {
      dialogTitle: 'Invitar Usuario a la Organización',
      emailAddress: 'Dirección de Correo *',
      emailPlaceholder: 'usuario@ejemplo.com',
      emailHelperText: 'El usuario recibirá un enlace de invitación por correo',
      selectRoles: 'Seleccionar Roles *',
      selectRolesHelper: 'Elige uno o más roles para asignar a este usuario',
      validation: {
        emailRequired: 'Se requiere correo electrónico',
        invalidEmail: 'Por favor ingresa una dirección de correo válida',
        selectRole: 'Por favor selecciona al menos un rol',
      },
      invitationNote:
        'El enlace de invitación expirará en 24 horas. El usuario será automáticamente asignado a tu organización cuando acepte la invitación.',
      cancel: 'Cancelar',
      sending: 'Enviando...',
      sendInvitation: 'Enviar Invitación',
      failedToSend: 'No se pudo enviar la invitación',
    },
  },

  // User Guide (EN placeholder — pending translation)
  guide: {
    title: 'User Guide',
    subtitle: 'Workflow guides for common tasks',
    backToDashboard: 'Back to Dashboard',
    headerTooltip: 'User Guide',
    common: {
      tip: 'Tip',
      important: 'Important',
    },
    sections: {
      uploadFlightData: 'Uploading & Analyzing Flight Data',
      shareFlights: "Sharing a Drone's Flights",
      maintenanceRecords: 'Maintenance Records',
      maintenanceRecordsCreating: 'Creating a Record',
      maintenanceRecordsQuality: 'Quality Checks',
      maintenanceRecordsSchedules: 'Reading Schedules',
      healthPanel: 'Reading the Health Panel',
      healthPanelAvgr: 'Understanding AVGR',
      healthPanelAvgt: 'Understanding AVGT',
      healthPanelTuwt: 'Understanding TUWT',
      healthPanelAction: 'When to Take Action',
      droneNotes: 'Drone Notes & Timeline',
      droneNotesCreating: 'Creating Notes',
      droneNotesFilters: 'Using Filters',
      droneNotesTimeline: 'Timeline Interaction',
      llmChat: 'AI Chat Assistant',
      llmChatSql: 'SQL Query Agent',
      llmChatMaintenance: 'Maintenance Agent',
      llmChatTips: 'Tips & Limits',
      inviteUsers: 'Inviting Users & Assigning Roles',
    },
    uploadFlightData: {
      intro:
        'Flight data files (CSV) require metadata before upload. This workflow walks you through uploading files and optionally analyzing them first.',
      steps: {
        s1: 'Navegue a la pestaña Archivos.',
        s2: 'Open the folder where you want to upload files.',
        s3: 'Click "Upload Files" to expand the upload zone.',
        s4: 'Drag and drop files into the upload zone, or click to browse your computer.',
        s5: 'For CSV flight data files, fill in the required metadata: flight type, payload, and pilot. These fields are mandatory for flight data.',
        s6: 'Optionally, click "Analyze" on a file to preview extracted metadata (rows, columns, detected values) before uploading.',
        s7: 'Click the upload button to upload all selected files.',
      },
      tipDocuments:
        'Document files (PDF, images) do not require flight metadata — they are uploaded directly.',
      tipAnalyze:
        'Use the "Analyze" button to validate a file before uploading. This lets you confirm the file has the expected data without committing to an upload.',
      tipPlotting:
        'To visualize and explore uploaded flight data in detail, use the "Plot Flight Data" button in the dashboard header. It opens the plotting tool where you can browse your folder structure, select a CSV file, and chart individual parameters from the flight.',
    },
    shareFlights: {
      intro:
        'Your organization can share every flight of one drone with XER Technologies in one action, for example so XER can support the aircraft. Each shared flight comes with its CSV log file and the .bin logs linked to it.',
      steps: {
        s1: 'Go to the "{{files}}" tab, open "{{sharedWithMe}}" and pick the "{{flights}}" tab.',
        s2: 'Click "{{openBulk}}".',
        s3: '{{drone}}: pick the drone\'s serial number (for example 105). {{organization}}: XER Technologies. Leave "{{fromDate}}" empty: it uses the drone\'s recorded handover date. {{access}}: "{{read}}".',
        s4: 'Click "{{share}}". A message confirms how many flights were shared.',
      },
      whatTheySee:
        'The other organization then finds these flights under "{{sharedWithMe}}", "{{flights}}", "{{inbound}}", and can open and download each flight\'s CSV log file. "{{read}}" lets them see and download the flights and nothing more: they cannot change or delete them. Shared flights do not count toward the other organization\'s own fleet totals. To stop sharing a flight, use "{{unshare}}" on it under "{{outbound}}".',
      whereTheyAppear:
        'Besides "{{sharedWithMe}}", shared flights appear on the drone\'s own pages (its profile timeline, flight list and Health panel), each marked as shared by your organization, and the drone\'s counters there say how many shared flights they include.',
      warningAdmins: 'Only organization admins see the "{{openBulk}}" button.',
      tipReshare:
        'Sharing covers the flights uploaded so far, not later ones. After you upload new flights for the drone, repeat these steps and click "{{share}}" again: only the new flights are added, and flights that are already shared are skipped.',
      tipBinLogs:
        '"{{openBulk}}" shares the drone\'s CSV flight logs, and every .bin log linked to one of those flights. When you upload a .bin log, the Dashboard looks for a flight of the same day with a matching start time and asks whether they are the same flight: answer "{{sameFlight}}" to link them. For a .bin log uploaded earlier, right-click it in the "{{files}}" tab and choose "{{linkFlight}}". A linked log follows the flight: whoever the flight is shared with can open it, and revoking the flight share withdraws it. Sharing the folder that holds the .bin logs ("{{shareFolder}}", XER Technologies under "{{folderOrganization}}", "{{folderShare}}") still works as well.',
      tipHandoverDate:
        'If the dialog says no handover date is recorded for the drone, enter the date your organization took the drone over in "{{fromDate}}" and click "{{share}}" again. Flights before that date are XER\'s own acceptance flights and are not shared.',
    },
    maintenanceRecords: {
      intro:
        'Maintenance records track work performed on a drone. Creating a record and having it quality-checked are separate steps done by different users.',
      layoutDescription:
        'The Maintenance tab has two panels: Upcoming Maintenance shows what is due or overdue based on hour intervals, and Maintenance History shows completed records.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Maintenance tab.',
          s2: 'Click "Add Maintenance" to open the maintenance record form.',
          s3: 'Select one or more maintenance types. You can also create a new type on-the-fly if the one you need does not exist.',
          s4: 'Fill in the work description explaining what was done.',
          s5: 'Select who performed the maintenance.',
          s6: 'Set the start and end dates for when the work was carried out.',
          s7: 'Attach any evidence files (photos, reports) during creation.',
          s8: 'Save the record.',
        },
      },
      warningAttachments:
        'File attachments can only be added when creating the record. You cannot attach files after the record has been saved.',
      quality: {
        description:
          'After a maintenance record is created, a different user must quality-check it. The person who created the record cannot approve their own work.',
        warningDifferentUser:
          'Quality checks require a different user than the one who created the record. This is enforced by the system.',
      },
      schedules: {
        description:
          'Upcoming maintenance is based on hours-based intervals configured for each maintenance type. The panel shows how many hours remain until maintenance is due, or how many hours overdue it is. Red indicators mean the maintenance is overdue and should be performed as soon as possible.',
      },
      tipNewTypes:
        'You can create new maintenance types on-the-fly from the maintenance record form. This is useful when a new type of work is performed for the first time.',
    },
    healthPanel: {
      intro:
        'The Health Panel provides automated analysis of drone sensor data. It uses three different metric types to give you a complete picture of system health.',
      openingSteps: {
        s1: 'Select a drone from the fleet overview.',
        s2: 'Navigate to the Health Panel tab.',
        s3: 'Review the metric cards organized by system (Performance, Cooling, Batteries, etc.).',
      },
      avgr: {
        title: 'AVGR (Average Reading)',
        description:
          'AVGR shows a single value: the latest average reading for a sensor. It includes a status indicator — NORMAL (within expected range) or WARNING (outside expected range). Use this to quickly check if a sensor is currently within acceptable limits.',
      },
      avgt: {
        title: 'AVGT (Average Trend)',
        description:
          'AVGT shows a historical trend line calculated using linear regression. It includes a trend direction (IMPROVING, STABLE, or WORSENING), a forecast value for a future date, and an R² confidence score. Higher R² means the forecast is more reliable.',
        warningRSquared:
          'A low R² value (below 0.5) means the data has high variability and the forecast may not be reliable. Do not make critical decisions based on low-confidence forecasts alone.',
      },
      tuwt: {
        title: 'TUWT (Time Under Warning Threshold)',
        description:
          'TUWT shows how much time a sensor spent in warning or error state, expressed as a percentage of total monitoring time. Warning time means the sensor was outside normal range. Error time means the sensor was in a critical state.',
      },
      action: {
        description:
          'Consider taking action when: TUWT error percentage is high, AVGT shows a worsening trend with high R², or AVGR shows WARNING status consistently. Combine multiple indicators rather than relying on any single metric.',
      },
      tipDataPoints:
        'Trend analysis requires at least 3 data points. With fewer data points, the Health Panel will show the message "Insufficient data for trend analysis" instead of a forecast.',
    },
    droneNotes: {
      intro:
        'Notes let you document observations, customer feedback, and alerts for a drone. The timeline view connects notes to flight data visually.',
      creating: {
        steps: {
          s1: 'Select a drone, then navigate to the Profile tab.',
          s2: 'Click "Create Note" (or the + button) in the Notes section.',
          s3: 'Enter a subject line for the note.',
          s4: 'Select the note type: General, Customer Feedback, or Alert.',
          s5: 'Set the priority: Information or Critical.',
          s6: 'Write the note content.',
          s7: 'Save the note.',
        },
      },
      filters: {
        description:
          'Use the filter controls to narrow down the notes list. You can filter by type (General, Customer Feedback, Alert), priority (Information, Critical), and whether resolved notes are included.',
      },
      timeline: {
        description:
          'The timeline at the top of the Profile tab shows a Gantt chart of flight data. Clicking a flight bar in the timeline scrolls down to and highlights the corresponding note below. This helps you connect specific flights to related observations.',
        tipDateRange:
          'The date range slider filters the notes list but does not affect the timeline view. The timeline always shows all available data.',
      },
    },
    llmChat: {
      intro:
        'The platform includes an AI chat assistant accessible via the floating button in the bottom-right corner of the dashboard. You choose an agent, then ask questions in natural language.',
      steps: {
        s1: 'Click the chat bubble in the bottom-right corner of the screen.',
        s2: 'Select an agent: SQL Query Agent for data questions, or Maintenance Agent for technical documentation.',
        s3: 'Type your question or click one of the example queries shown.',
        s4: 'Review the response. For SQL queries, you can expand "View SQL" to see the exact query that was executed.',
      },
      sql: {
        title: 'SQL Query Agent',
        description:
          'Ask questions about your fleet data in plain language. The agent converts your question into a SQL query, runs it against the database, and returns the results in readable form. You only see data from your own organization — this is enforced automatically.',
        examples:
          'Example questions: "How many flights under 10 minutes for drone 102?", "What is the total flight time this month?", "Show me drones that need maintenance", "How many unresolved notes are there?"',
      },
      maintenance: {
        title: 'Maintenance Agent',
        description:
          'Ask questions about maintenance procedures, safety protocols, and technical specifications. The agent searches uploaded maintenance documentation (manuals, procedures, tool specs) and synthesizes an answer with source citations. Answers reference specific document sections and page numbers.',
        examples:
          'Example questions: "How do I replace the propellers?", "What are the safety protocols for battery maintenance?", "Troubleshooting steps for motor failure", "What tools do I need for routine inspection?"',
      },
      tips: {
        rateLimit:
          'You are limited to 20 queries per hour. The limit resets automatically. If you reach it, wait and try again later.',
        feedback:
          'Use the thumbs up/down buttons on responses to provide feedback. This helps improve the quality of answers over time. Thumbs down lets you add an optional comment explaining what was wrong.',
        privacy:
          'All queries are scoped to your organization. The SQL agent can only read data — it cannot modify, delete, or create anything in the database.',
        session:
          'The chat remembers your conversation within a session. Click the refresh icon in the chat header to start a new session and switch agents.',
      },
    },
    inviteUsers: {
      intro:
        'When you invite a user, they receive an email link. Once they accept and create their account, they are automatically assigned to your organization with the roles you selected.',
      steps: {
        s1: 'Navigate to Admin Tools.',
        s2: 'In the User Management section, click "Invite User".',
        s3: "Enter the user's email address and select one or more roles.",
        s4: 'Click "Send Invitation". The user receives an email with a link to create their account.',
        s5: 'When the user clicks the link and creates their password, they are automatically assigned to your organization with the selected roles.',
        s6: 'The user can now sign in and access the system immediately.',
      },
      warningExpiry:
        'Invitation links expire in 24 hours. If the link expires, you need to send a new invitation.',
      warningUnassigned:
        'The "Unassigned Users" list in Organization Management shows users who registered on their own (without an invitation). These users must be manually assigned to an organization by an admin before they can access the system.',
    },
  },

  inventory: {
    title: 'Inventario',
    locations: 'Ubicaciones',
    items: 'Artículos',
    allItems: 'Todos los artículos',
    addLocation: 'Agregar ubicación',
    addItem: 'Agregar artículo',
    editLocation: 'Editar ubicación',
    editItem: 'Editar artículo',
    deleteLocation: 'Eliminar ubicación',
    deleteItem: 'Eliminar artículo',
    confirmDeleteLocation:
      '¿Está seguro de que desea eliminar esta ubicación? Todas las ubicaciones secundarias también se eliminarán. Los artículos en ubicaciones eliminadas quedarán sin asignar.',
    confirmDeleteItem: '¿Está seguro de que desea eliminar este artículo?',
    name: 'Nombre',
    locationType: 'Tipo',
    parentLocation: 'Ubicación principal',
    notes: 'Notas',
    quantity: 'Cantidad',
    category: 'Categoría',
    location: 'Ubicación',
    search: 'Buscar artículos...',
    noLocations: 'Aún no hay ubicaciones. Agregue su primera ubicación para comenzar.',
    noItems: 'No se encontraron artículos.',
    noItemsInLocation: 'No hay artículos en esta ubicación.',
    sortOrder: 'Orden',
    locationTypes: {
      area: 'Área',
      shelf: 'Estante',
      level: 'Nivel',
      box: 'Caja',
      pelicase: 'Pelicase',
      bag: 'Bolsa',
      section: 'Sección',
      bucket: 'Cubo',
      container: 'Contenedor',
    },
    actions: 'Acciones',
    searchLocations: 'Buscar ubicaciones...',
    locationPath: 'Ver ruta de ubicación',
    backTo: 'Volver a {{name}}',
    rootLevel: 'Raíz',
    noSelection: 'Sin selección',
  },

  operationsEquipment: {
    title: 'Equipo de Operaciones',
    add: 'Agregar Equipo',
    addTitle: 'Agregar Equipo',
    edit: 'Editar',
    editTitle: 'Editar Equipo',
    delete: 'Eliminar Equipo',
    confirmDelete: '¿Está seguro de que desea eliminar este equipo?',
    name: 'Nombre',
    location: 'Ubicación',
    quantity: 'Cantidad',
    drone: 'Dron',
    photo: 'Foto',
    photoUrl: 'URL de Foto',
    notes: 'Notas',
    actions: 'Acciones',
    noEquipment: 'Aún no hay equipo de operaciones. Agregue su primer equipo para comenzar.',
  },

  // Manufacturing (STD-015 query/mutation error fallbacks)
  manufacturing: {
    failedToCheckAccess: 'No se pudo verificar el acceso a fabricación',
    failedToLoad:
      'No se pudieron cargar los datos de fabricación. Verifique que los scripts de snapshot se hayan ejecutado.',
    failedToLoadPartDetail: 'No se pudo cargar el detalle de la pieza',
    failedToSimulate:
      'La simulación falló. Confirme que el producto tenga una lista de materiales e inténtelo de nuevo.',
  },

  // Comparticion de vuelos (#1182 Etapa 3) — solo queda el dialogo masivo por
  // numero de serie; las cadenas del dialogo por archivo se retiraron con el en
  // B-6 (STD-029 R-12), vease en.ts.
  flightShares: {
    selectOrganization: 'Organizacion',
    permission: 'Acceso',
    permissionRead: 'Lectura',
    permissionWrite: 'Lectura + editar detalles',
    permissionHelp:
      'Lectura permite a la otra organizacion ver y descargar los vuelos. Lectura + editar detalles tambien le permite editar los detalles de cada vuelo (tipo, piloto, carga util, cliente, proyecto). Solo su organizacion puede eliminar un vuelo.',
    nothingNewToShare: 'Todos los vuelos coincidentes ya estaban compartidos - nada que hacer.',
    sharedOne: 'Se compartio 1 vuelo.',
    sharedOther: 'Se compartieron {{count}} vuelos.',
    skippedOne: '1 ya estaba compartido.',
    skippedOther: '{{count}} ya estaban compartidos.',
    droneOwnedBy: 'Propiedad de {{org}}.',
    droneFlightsOne: '1 vuelo registrado por su organizacion con el.',
    droneFlightsOther: '{{count}} vuelos registrados por su organizacion con el.',
    noShareableDrones: 'Su organizacion aun no tiene vuelos registrados para compartir.',
    onlyAdmins: 'Solo los administradores de la organizacion pueden cambiar la comparticion.',
    bulkTitle: 'Compartir los vuelos de un dron',
    bulkIntro:
      'Comparte en una sola accion todos los vuelos que su organizacion registro para este dron, en lugar de uno por uno. Se puede repetir: los vuelos ya compartidos se omiten.',
    drone: 'Dron',
    fromDate: 'Desde la fecha',
    toDate: 'Hasta la fecha',
    fromDateHelp: 'Dejar vacio para usar la fecha de entrega registrada del dron.',
    bulkShare: 'Compartir vuelos',
    errors: {
      noSoldDate:
        'No hay fecha de entrega registrada para el dron {{serial}}, por lo que no existe un corte defendible entre los vuelos previos a la entrega de XER y los del cliente. Introduzca abajo, en "Desde la fecha", la fecha en que el cliente recibio la aeronave.',
      noFlights: 'Ningun vuelo de su organizacion coincidio - no se compartio nada.',
      illegalPairing:
        'Los vuelos solo pueden compartirse entre XER Technologies y una organizacion cliente, en ambos sentidos, nunca entre dos clientes.',
    },
  },

  objectShares: {
    menuItemFile: 'Compartir archivo...',
    menuItemFolder: 'Compartir carpeta...',
    menuItemMany: 'Compartir {{count}} elementos...',

    dialogTitle: 'Compartir - {{name}}',
    dialogTitleMany: 'Compartiendo {{count}} elementos',
    multiSelection:
      'Se compartiran los {{count}} elementos seleccionados. Las comparticiones existentes se mantienen: lo que ya este compartido con la organizacion elegida se omite.',
    folderCoversFutureFiles:
      'Al compartir una carpeta se comparte todo su contenido, incluidos los archivos que se anadan mas adelante. No hace falta compartir cada archivo nuevo.',
    currentShares: 'Acceso actual',
    noShares: 'Esto no esta compartido con nadie.',
    sharedWithOrg: 'Compartido con {{org}}',
    sharedByOrg: 'Compartido con nosotros por {{org}}',
    sharedDirectionUnknown: 'Compartido (destinatario no disponible)',
    unknownOrg: 'Otra organizacion',
    grantedOn: 'Concedido el {{date}}',

    revoke: 'Dejar de compartir',
    revokeConfirm: 'Dejar de compartir este archivo con {{org}}? El acceso termina de inmediato.',
    revokeConfirmFolder:
      'Dejar de compartir esta carpeta con {{org}}? Perderan el acceso a todo su contenido, incluidos los archivos anadidos desde que se compartio.',
    revokeSuccess: 'Se dejo de compartir.',

    shareWith: 'Compartir con',
    selectOrganization: 'Organizacion',
    permission: 'Acceso',
    permissionRead: 'Lectura',
    permissionWrite: 'Lectura + escritura',
    permissionHelp:
      'Lectura permite a la otra organizacion ver y descargar este archivo. Lectura + escritura le permite ademas cambiarle el nombre. Solo su propia organizacion puede eliminarlo.',
    permissionHelpFolder:
      'Lectura permite a la otra organizacion ver y descargar todo el contenido de esta carpeta, incluidos los archivos anadidos mas adelante. Lectura + escritura le permite ademas crear carpetas y cambiar el nombre o mover los elementos que contiene. Todavia no puede subir archivos a esta carpeta desde la pestana Archivos, porque esas subidas no se procesarian como vuelos. Solo su propia organizacion puede eliminar su contenido.',
    share: 'Compartir',
    noCounterparties: 'No hay ninguna organizacion con la que pueda compartir esto.',
    sharedOne: 'Se compartio 1 elemento.',
    sharedOther: 'Se compartieron {{count}} elementos.',
    skippedOne: '1 ya estaba compartido.',
    skippedOther: '{{count}} ya estaban compartidos.',
    onlyAdmins: 'Solo los administradores de la organizacion pueden cambiar el uso compartido.',

    errors: {
      noObjects:
        'Ninguno de los elementos seleccionados pertenece a su organizacion, por lo que no habia nada que compartir.',
      illegalPairing:
        'Los archivos solo pueden compartirse entre XER Technologies y una organizacion cliente, en ambos sentidos, nunca entre dos clientes.',
    },
  },

  flightLinks: {
    menuItem: 'Vincular a un vuelo...',
    dialogTitle: 'Vincular a un vuelo - {{name}}',
    intro:
      'Un registro .bin vinculado a un vuelo viaja con el: toda organizacion con la que se comparte el vuelo puede abrir y graficar el registro. Desvincularlo, o revocar el vuelo compartido, lo retira de nuevo.',
    current: 'Vinculado a',
    noLinks: 'Este registro no esta vinculado a ningun vuelo.',
    candidates: 'Vuelos a los que puede pertenecer este registro',
    day: 'Dia',
    logStart: 'Registro iniciado {{time}} (segun el nombre del archivo).',
    noLogStart:
      'El nombre del archivo no contiene hora de inicio, asi que no se marca ningun vuelo. Elija el dia en que se grabo.',
    noCandidates:
      'Ningun vuelo visible de la organizacion de este registro ese dia. Elija otro dia.',
    proposed: 'Coincidencia probable',
    deltaLogName: '{{minutes}} min del nombre del CSV',
    deltaFirstSample: '{{minutes}} min de la primera muestra (UTC)',
    flightOn: 'Dron {{serial}}, {{date}}',
    sharedWith: 'Compartido con {{orgs}}: vincularlo les da este registro',
    sharedWithLinked: 'Compartido con {{orgs}}, que pueden abrir este registro',
    notShared: 'Vuelo no compartido',
    unknownOrg: 'Otra organizacion',
    link: 'Vincular',
    unlink: 'Desvincular',
    unlinkConfirm:
      'Desvincular este registro del vuelo? Las organizaciones con las que se comparte el vuelo pierden el acceso al registro al instante.',
    linked: 'Vinculado.',
    alreadyLinked: 'Ya estaba vinculado.',
    unlinked: 'Desvinculado.',
    promptTitle: 'Es el mismo vuelo?',
    promptQuestion: '{{bin}} y {{flight}} empezaron casi a la misma hora.',
    promptNo: 'No',
    promptYes: 'Si, es el mismo vuelo',
  },

  sharedView: {
    navLabel: 'Compartido conmigo',
    title: 'Compartido conmigo',
    backToFiles: 'Volver a archivos',
    kindFlights: 'Vuelos',
    kindFiles: 'Archivos',
    flightsIntro: 'Vuelos compartidos entre su organizacion y otras.',
    flightsIntroDetail:
      'Un vuelo compartido incluye su archivo de registro y los registros .bin vinculados a el, asi que se abren como cualquier otro archivo. Lo que comparte su organizacion aparece en "Compartido por nosotros"; lo que otros comparten con usted, en "Compartido con nosotros".',
    filesIntro: 'Archivos y carpetas compartidos entre su organizacion y otras.',
    filesIntroDetail:
      'Compartir una carpeta comparte todo su contenido, incluidos los archivos anadidos despues, por lo que pueden aparecer elementos aqui sin haberse compartido individualmente.',
    aboutThisPage: 'Acerca de esta pagina',

    outbound: 'Compartido por nosotros',
    inbound: 'Compartido con nosotros',
    allShares: 'Todos los recursos compartidos',
    filterCounterparty: 'Organizacion',
    allCounterparties: 'Todas las organizaciones',
    unknownOrg: 'Otra organizacion',
    includeRevoked: 'Incluir revocados',
    openBulk: 'Compartir los vuelos de un dron',
    onlyAdmins: 'Solo los administradores de la organizacion pueden cambiar el uso compartido.',

    permissionRead: 'Lectura',
    permissionWrite: 'Lectura + escritura',
    droneChip: 'Dron {{serial}}',
    flightOn: 'Vuelo {{date}}',
    trackLabel: 'Track de DroneLogbook · {{date}}',
    trackLabelUndated: 'Track de DroneLogbook',
    trackTooltip: 'Un registro de vuelo de DroneLogbook, sin archivo de registro.',
    grantedOn: 'Concedido {{date}}',
    revokedOn: 'Revocado {{date}}',
    unnamedEntry: 'Archivo no disponible',

    openFolder: 'Abrir carpeta',
    download: 'Descargar',
    downloadStarted: 'Descarga iniciada.',
    plot: 'Abrir en Analytics',
    revoke: 'Dejar de compartir',
    revokeConfirm:
      'Dejar de compartir esto con {{org}}? El acceso termina de inmediato; lo ya derivado sigue siendo valido.',
    revokeSuccess: 'Se dejo de compartir.',

    rowsPerPage: 'Elementos por pagina',
    paginationRange: '{{from}}-{{to}} de {{count}}',
    noneShared: 'Todavia no hay nada aqui.',
    noneForOrg: 'No hay nada compartido con esta organizacion.',
    emptyOutboundFlights:
      'Actualmente su organizacion no comparte ningun vuelo. Un administrador de la organizacion puede compartir los vuelos de un dron desde esta pagina.',
    emptyOutboundFiles:
      'Actualmente su organizacion no comparte archivos ni carpetas. Compartalos desde su menu en Archivos.',
    emptyInboundFlights:
      'Actualmente ninguna organizacion comparte vuelos con la suya. Los vuelos compartidos con usted aparecen aqui, con sus archivos de registro.',
    emptyInboundFiles:
      'Actualmente ninguna organizacion comparte archivos ni carpetas con la suya.',
  },
} as const;
